import IComponent from "components/commons/IComponent";
import Slider from "@material-ui/core/Slider";
import ColorPicker from "components/commons/ColorPicker";
import "./GraphicStyleEditor.scoped.css";
import EditableDatagridCell from "components/commons/EditableDatagridCell";

const SYMBOL_PROPERTIES = {
  "simple-fill": ["color", "style", "outline"],
  "simple-marker": ["color", "style", "size", "outline"],
  "simple-line": ["color", "style", "width"],
  text: ["text", "color", "horizontalAlignment", "font"],
  font: ["family", "size", "style", "weight"],
};
const PROP_NAME_LABEL_LUT = {
  horizontalAlignment: "Text alignment",
};
const DROPDOWN_OPTIONS = {
  style: {
    "simple-line": [
      "dash",
      "dash-dot",
      "dot",
      "long-dash",
      "long-dash-dot",
      "long-dash-dot-dot",
      "none",
      "short-dash",
      "short-dash-dot",
      "short-dash-dot-dot",
      "short-dot",
      "solid",
    ],
    "simple-marker": [
      "circle",
      "square",
      "cross",
      "x",
      "diamond",
      "triangle",
      "path",
    ],
    "simple-fill": [
      "backward-diagonal",
      "cross",
      "diagonal-cross",
      "forward-diagonal",
      "horizontal",
      "none",
      "solid",
      "vertical",
    ],
    font: ["normal", "italic", "oblique"],
  },
  weight: {
    font: ["normal", "bold", "bolder", "lighter"],
  },
  family: {
    font: [
      "arial",
      "broadway",
      "algerian",
      "courier",
      "serif",
      "verdana",
      "Josefin Slab",
    ],
  },
  horizontalAlignment: {
    text: ["left", "right", "center"],
  },
};
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    // let symbol = props.graphic.symbol.clone();
    // this.state = { symbol };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  createControls(symbol, symbolType) {
    let type = symbolType || symbol.type;
    // let color = this.arrayColorToRgbColor(symbol.color);
    let color = symbol.color;
    let lineSymbol = undefined;
    let components = SYMBOL_PROPERTIES[type].map((i) => {
      let reactObj = undefined;
      switch (i) {
        case "color":
          reactObj = (
            <ColorPicker
              color={color}
              onChange={(e) => this.changeHandler(symbol, "color", e)}
            />
          );
          break;
        case "width":
        case "size":
          let min = 0,
            max = 20;
          if (symbolType === "font") {
            min = 12;
            max = 48;
          }
          reactObj = (
            <Slider
              value={symbol[i]}
              min={min}
              max={max}
              onChange={(e1, e) => this.changeHandler(symbol, i, e)}
            />
          );
          break;
        case "weight":
        case "style":
        case "family":
        case "horizontalAlignment":
          let value = symbol[i];
          let valueIndex = DROPDOWN_OPTIONS[i][type].indexOf(value);
          valueIndex = valueIndex === -1 ? undefined : valueIndex;
          reactObj = (
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "valueIndex",
                  dataType: "dropdown",
                  values: DROPDOWN_OPTIONS[i][type],
                  required: false,
                },
                row: { valueIndex },
              }}
              onChange={(field, value, values) =>
                this.changeHandler(symbol, i, values[value])
              }
              style={{ height: "40px" }}
            />
          );
          break;
        case "outline":
          lineSymbol = this.createControls(symbol.outline, "simple-line");
          return (
            <div>
              <b>Outline Style</b>
            </div>
          );
        case "font":
          lineSymbol = this.createControls(symbol.font, "font");
          return (
            <div>
              <b>Font Style</b>
            </div>
          );
        case "text":
          reactObj = (
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "value",
                  dataType: "text",
                  required: false,
                  materialUiProps: {
                    classes: {
                      root: "SmallerMUIController",
                    },
                  },
                },
                row: { value: symbol.text },
              }}
              onChange={(field, value, values) =>
                this.changeHandler(symbol, i, value)
              }
            />
          );
          break;
        default:
          return <div>&nbsp;</div>;
      }
      return (
        <div>
          <div>{PROP_NAME_LABEL_LUT[i] || i}</div>
          {reactObj}
        </div>
      );
    });
    if (lineSymbol) components.push.apply(components, lineSymbol);
    return components;
  }
  arrayColorToRgbColor(color) {
    if (!Array.isArray(color)) return undefined;
    return "rgba".split("").reduce((p, c, i) => ((p[c] = color[i]), p), {});
  }
  changeHandler(object, propName, value) {
    let symbol = this.props.graphic.symbol;
    object[propName] = value;
    this.setState({});
    this.props.onUpdate(symbol);
  }
  render() {
    let { symbol } = this.props.graphic;
    return (
      <div className="GraphicStyleEditorContainer">
        {this.createControls(symbol)}
      </div>
    );
  }
}

export default ClassName;
